export default "__VITE_ASSET__3eb34d18__"